module.exports = "<div class=\"inmodal modal-lg\">\n  <div class=\"color-line\"></div>\n  <div class=\"modal-header\">\n    <h5 class=\"modal-title\">Add User</h5>\n    <p class=\"text-danger\">{{errorMessage}}</p>\n  </div>\n  <div class=\"modal-body\">\n    <employee-create></employee-create>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./client/common/modals/addEmployeeModal/addEmployeeModal.html
// module id = 811
// module chunks = 0